export default "__VITE_ASSET__107460ab__"